import type { IMegaRewardsAccount } from "../../hooks/api/staking/useMegaRewards";

interface PerpRewardsSummary {
  accounts: IMegaRewardsAccount[];
  totalReward: number | undefined;
  totalPercentage: number | undefined;
}

const parseEstimate = (value: string | null | undefined): number | undefined => {
  if (value == null || value.trim() === "") return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};

const sumEstimates = (
  accounts: IMegaRewardsAccount[],
  field: "expected_reward_usdc" | "expected_reward_pool_percentage"
): number | undefined =>
  accounts.reduce<number | undefined>((total, account) => {
    const value = parseEstimate(account[field]);
    if (total === undefined || value === undefined) return undefined;
    const sum = total + value;
    return Number.isFinite(sum) ? sum : undefined;
  }, 0);

export const getPerpRewardsSummary = (
  rows: IMegaRewardsAccount[],
  getTag: (account: string) => string | undefined,
  withholdEstimates: boolean
): PerpRewardsSummary => {
  const accounts = rows
    .filter((row) =>
      /^Aevo\s+Rewards\s+Perp\s+\d+\b/i.test(getTag(row.account)?.trim() || "")
    )
    .sort((first, second) => {
      const firstReward = parseEstimate(first.expected_reward_usdc);
      const secondReward = parseEstimate(second.expected_reward_usdc);
      if (firstReward === undefined && secondReward !== undefined) return 1;
      if (secondReward === undefined && firstReward !== undefined) return -1;
      if (
        firstReward !== undefined &&
        secondReward !== undefined &&
        firstReward !== secondReward
      ) {
        return firstReward > secondReward ? -1 : 1;
      }
      if (first.account === second.account) return 0;
      return first.account < second.account ? -1 : 1;
    });

  return {
    accounts,
    totalReward: withholdEstimates
      ? undefined
      : sumEstimates(accounts, "expected_reward_usdc"),
    totalPercentage: withholdEstimates
      ? undefined
      : sumEstimates(accounts, "expected_reward_pool_percentage"),
  };
};
